import {Component, Inject} from '@angular/core';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { MasterCreateUserComponent } from '../master-create-user.component';
@Component({
  selector: 'dialog-create-user',
  templateUrl: 'dialog.component.html',
})
export class DialogCreateUser {

  constructor(
    public dialogRef: MatDialogRef<DialogCreateUser>,
    @Inject(MAT_DIALOG_DATA) public data: {data}) {}

  onClose(): void {
    this.dialogRef.close();
  }

}
